import { render, staticRenderFns } from "./GittigidiyorFinansman.vue?vue&type=template&id=1a5ddf1d"
import script from "./GittigidiyorFinansman.vue?vue&type=script&lang=js"
export * from "./GittigidiyorFinansman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports